import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { authorSchema, identitySchema } from '@/core/components';

import { defaultPaperValues, paperSchema } from '../../Paper/model/PaperSchema';

export const articleSchema = paperSchema.extend({
  type: identitySchema.nullable(),

  authors: z.array(authorSchema).min(1),
});

export const defaultArticleValues: DefaultValues<ArticleSchema> = {
  type: null,
  authors: [],
  ...defaultPaperValues,
};

export type ArticleSchema = z.infer<typeof articleSchema>;
